import nestAxios from './_nestAxios'

export const get = (idSocio, tipo) =>
  nestAxios.get(`/formularios-recordar`, {
    params: {
      idSocio,
      tipo
    }
  })
